/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckedInAt/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CheckedInAt({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/CheckedInAt"
  
}) {
let appointmentBookingCheckInTimeValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'check_in_time',
})
let globalCurrentLocationTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.time_zone_id',
})
let aggregateData = fromHelpers.getCheckInTimeInTZ(appointmentBookingCheckInTimeValueData, globalCurrentLocationTimeZoneIdValueData)
let appointmentBookingCheckInTimeValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'check_in_time',
})
let appointmentBookingStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'start_time',
})
let aggregateData1 = fromHelpers.isAfterStartTime(appointmentBookingCheckInTimeValueData1, appointmentBookingStartTimeValueData)
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtColorsRed700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700'
        })
  return (<React.Fragment
>
<div
  data-testid="CheckedInAt.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor="pointer"
 size="small"
 weight="semibold"
 color={aggregateData1 ? dtColorsRed700 : dtColorsGreen700}
 data="appointment_booking.check_in_time"
 data="global.current_location.time_zone_id"
 aggregate="helpers.js getCheckInTimeInTZ"
 text={aggregateData}
 data="appointment_booking.check_in_time"
 data="appointment_booking.start_time"
 aggregate="helpers.js isAfterStartTime"
/>
</div>
{children}
</React.Fragment>)
}